import {atom} from "jotai";
import {loadStringFromStorage, saveStringToLocalStorage} from "../services/localStorageService";
import {FieldHistoryDaysType} from "../types/fieldHistoryDays";

const LOCAL_STORAGE_FIELD_HISTORY_DAYS_KEY = "fieldHistoryDays";

const loadFieldHistoryDays = (): FieldHistoryDaysType => {
    const storedValue = loadStringFromStorage(LOCAL_STORAGE_FIELD_HISTORY_DAYS_KEY, "30");
    return storedValue === "ALL" ? storedValue : parseInt(storedValue);
};

const fieldHistoryDaysPrimitiveAtom = atom<FieldHistoryDaysType>(loadFieldHistoryDays());

export const fieldHistoryDaysAtom = atom<FieldHistoryDaysType, [FieldHistoryDaysType], void>(
    (get) => get(fieldHistoryDaysPrimitiveAtom),
    (_get, set, historyDays) => {
        set(fieldHistoryDaysPrimitiveAtom, historyDays);
        saveStringToLocalStorage(LOCAL_STORAGE_FIELD_HISTORY_DAYS_KEY, historyDays.toString());
    },
);
